export default "__VITE_ASSET__BO2MnQW2__"